module.exports = __webpack_public_path__ + "img/u656b.53b8d0a9.jpg";